import { CommonEffects } from '@Common/common.effects';
import { CommonReducer } from '@Common/common.reducer';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { LocalStorageService } from '@Services/local-storage.service';
import { SecureLocalStorageService } from '@Services/secure-local-storage.service';
import { FlexSearchService } from 'src/app/index/flex-search.service';
import { RequestIndexerService } from 'src/app/index/indexer/request-indexer.service';
import { SharedPdsIndexerService } from 'src/app/index/indexer/shared-pds-indexer.service';
import { TaskService } from './task/task.service';
import { NewsService } from './news/news.service';

export const provideOrganisationFeature = () => [
  provideState('common', CommonReducer),
  provideEffects(CommonEffects),
  FlexSearchService,
  SharedPdsIndexerService,
  RequestIndexerService,
  LocalStorageService,
  SecureLocalStorageService,
  TaskService,
  NewsService,
];
